import { Box, IconButton, Typography } from "@mui/material";
import { CommonStyle, ControlledForm } from "Components";
import CstmBtn from "Components/CstmBtn";
import ImgPath from "Constant/Imgs";
import { RouteUrls } from "Constant/RouteUrls";
import { FC, Fragment, useEffect, useState } from "react";
import { CheckStringEmpty } from "Utils/common";
import CommonFormatter from "Utils/Common.Formatter";
import { PlanData } from "./Data";
import { useNavigate } from "react-router-dom";

export interface PlanDataType {
  id: number;
  text: string;
  category: "goals" | "intervention"
}

const PlanDetails: FC = () => {
  const navigate = useNavigate();
  const [dataArr, setDataArr] = useState<PlanDataType[]>(PlanData);
  const [editChanges, setEditChanges] = useState<PlanDataType | null>(null);

  useEffect(() => {
    CommonFormatter.HandleNavArr({
      id: "upload patient",
      label: "Plan Details",
      path: `/${RouteUrls.hs}/${RouteUrls.organization}` +
        `/${RouteUrls.preApprovedPlan}`,
      level: 5,
      link: RouteUrls.preApprovedPlan,
      navType: "org",
    });
  }, []);

  const handleAddGoal: () => void = () => {
    const newObj: PlanDataType = {
      category: "goals",
      id: dataArr.length + 1,
      text: ""
    }
    setDataArr([...dataArr, newObj]);
    setEditChanges(newObj);
  };

  const handleAddInter: () => void = () => {
    const newObj: PlanDataType = {
      category: "intervention",
      id: dataArr.length + 1,
      text: ""
    }
    setDataArr([...dataArr, newObj]);
    setEditChanges(newObj);
  };

  const handleSaveChanges: () => void = () => {
    setEditChanges(null);
    setDataArr([...dataArr.slice(0, 11),])
  };

  const handleClose: () => void = () => {
    setEditChanges(null);
    setDataArr([...dataArr.slice(0, 11),])
  };

  return (
    <Box height="91%" sx={{ ...CommonStyle.sxWhiteBox, overflow: "auto" }}>
      <Box sx={{ p: 2 }}>
        <Typography mb={2}><b>Problem Name :</b> Asthma</Typography>
        <Box width={"50%"}>
          <Typography color="black" fontWeight={"bold"}>Goals</Typography>
          {dataArr.filter(el => el.category == "goals").map(el => {
            return (
              <Box
                key={el.id}
                display={"flex"}
                justifyContent={"space-between"}
                alignItems="center"
                sx={{
                  border: "1px solid",
                  borderColor: "custom.main",
                  borderRadius: "5px",
                  p: 1
                }}>
                {editChanges && editChanges.id == el.id ?
                  <ControlledForm.InputApi
                    id="EditText"
                    inputVal={editChanges.text}
                    inputChange={(val) => {
                      setEditChanges({
                        ...editChanges,
                        text: CheckStringEmpty(val)
                      })
                    }}
                  /> :
                  (<Typography variant="body2">
                    {el.text}
                  </Typography>)
                }
                <Box display={"flex"}>
                  {editChanges?.id == el.id ?
                    <Fragment>
                      <IconButton
                        sx={{ ...CommonStyle.sxRoundIconsMainMd, mr: 0.5 }}
                        onClick={handleSaveChanges}
                      >
                        <ImgPath.SaveIcon />
                      </IconButton>
                      <IconButton
                        sx={{ ...CommonStyle.sxRoundIconsMainMd, mr: 0.5 }}
                        onClick={handleClose}
                      >
                        <ImgPath.CloseIcon />
                      </IconButton>
                    </Fragment>
                    :
                    <Fragment>
                      <IconButton
                        sx={{ ...CommonStyle.sxRoundIconsMainMd, mr: 0.5 }}
                        onClick={() => setEditChanges(el)}
                      >
                        <ImgPath.EditOutlined />
                      </IconButton>
                      <IconButton
                        sx={{ ...CommonStyle.sxRoundIconsMainMd, mr: 0.5 }}
                      >
                        <ImgPath.DeleteOutline />
                      </IconButton>
                    </Fragment>
                  }
                </Box>
              </Box>
            )
          })}
          <CstmBtn
            label="Add More"
            onClick={handleAddGoal}
            sxProps={{ mt: 1 }}
            disable={editChanges ? true : false}
          />
          <Typography color="black" fontWeight={"bold"} mt={4}>
            Interventions
          </Typography>
          {dataArr.filter(el => el.category == "intervention").map(el => {
            return (
              <Box
                key={el.id}
                display={"flex"}
                justifyContent={"space-between"}
                alignItems="center"
                sx={{
                  border: "1px solid",
                  borderColor: "custom.main",
                  borderRadius: "5px",
                  p: 1
                }}>
                {editChanges && editChanges.id == el.id ?
                  <ControlledForm.InputApi
                    id="EditText"
                    inputVal={editChanges.text}
                    inputChange={(val) => {
                      setEditChanges({
                        ...editChanges,
                        text: CheckStringEmpty(val)
                      })
                    }}
                  /> :
                  (<Typography variant="body2">
                    {el.text}
                  </Typography>)
                }
                <Box display={"flex"}>
                  {editChanges?.id == el.id ?
                    <Fragment>
                      <IconButton
                        sx={{ ...CommonStyle.sxRoundIconsMainMd, mr: 0.5 }}
                        onClick={handleSaveChanges}
                      >
                        <ImgPath.SaveIcon />
                      </IconButton>
                      <IconButton
                        sx={{ ...CommonStyle.sxRoundIconsMainMd, mr: 0.5 }}
                        onClick={handleClose}
                      >
                        <ImgPath.CloseIcon />
                      </IconButton>
                    </Fragment>
                    :
                    <Fragment>
                      <IconButton
                        sx={{ ...CommonStyle.sxRoundIconsMainMd, mr: 0.5 }}
                        onClick={() => setEditChanges(el)}
                      >
                        <ImgPath.EditOutlined />
                      </IconButton>
                      <IconButton
                        sx={{ ...CommonStyle.sxRoundIconsMainMd, mr: 0.5 }}
                      >
                        <ImgPath.DeleteOutline />
                      </IconButton>
                    </Fragment>
                  }
                </Box>
              </Box>
            )
          })}
          <CstmBtn
            label="Add More"
            onClick={handleAddInter}
            sxProps={{ mt: 1 }}
            disable={editChanges ? true : false}
          />
          <Box textAlign={"end"}>
            <CstmBtn
              label="Save Changes"
              onClick={() => navigate(-1)}
              sxProps={{ mt: 1, p: 2 }}
            />
          </Box>
        </Box>
      </Box>
    </Box>
  )
};

export default PlanDetails;